import { validators } from 'vue-form-generator'
export default {
  data () {
    return {}
  },
  methods: {
    uploadSaveCustomForms () {
      return new Promise(resolve => {
        this.$store.dispatch('getCustomForms').then(response => {
          if (response) {
            let forms = JSON.parse(response.data.result.forms)
            this.$store.commit('saveCustomForms', forms)
            resolve(forms)
          }
        }).catch(err => {
          console.log(err)
        })
      })
    },
    getCustomFormsLabelsArray () {
      let forms = this.$store.state.customForms
      let labels = []
      forms.forEach(item => {
        labels.push(item.formLabel)
      })
      return labels
    },
    getCustomFormsNamesArray () {
      let forms = this.$store.state.customForms
      let formNames = []
      forms.forEach(item => {
        formNames.push(item.formName)
      })
      return formNames
    },
    getCustomFormfields (formname) {
      if (!formname) return
      let forms = this.$store.state.customForms
      let formfields = []
      let form = forms.filter((item) => { return item.formName === formname })
      formfields = form[0].fields
      formfields.forEach(element => {
        if (element.required) {
          element['validator'] = validators.string
        }
      })
      return formfields
    },
    getCustomFormModel (formfields) {
      let modelObject = {}
      if (!formfields) return
      formfields.forEach(element => {
        modelObject[element.model] = ''
      })
      return modelObject
    }
  }
}
